import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStar"><Path d="M12.0008 0.258789L8.6191 7.34576L0.833984 8.37198L6.52908 13.7782L5.09934 21.4994L12.0008 17.7537L18.9023 21.4994L17.4726 13.7782L23.1677 8.37198L15.3826 7.34576L12.0008 0.258789Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStar;
